module.exports = __webpack_public_path__ + "img/Anthony.5086df66.png";